<section class="py-6 border-b border-b-shs-gray-4" [formGroup]="referenceNumberInternationalForm!">
    <h2 class="text-base font-bold text-font-primary">Order Details</h2>
    <div class="max-w-input mt-4 flex flex-col gap-4">
        <sag-ui-select
            [required]="true"
            label="Reference Number Type"
            placeholder="Select Number Type"
            formControlName="referenceNumberType"
        >
            @for (refernceNumberType of refernceNumberTypes | keyvalue; track $index) {
            <sag-ui-option [value]="refernceNumberType.value">{{ refernceNumberType.value }}</sag-ui-option>
            }
        </sag-ui-select>
        <sag-ui-input
            [required]="true"
            label="Reference Number of the affected order or shipment"
            placeholder="Enter Number"
            formControlName="referenceNumber"
        >
            <span ngProjectAs="end-decorator" class="flex items-center justify-center h-full p-1 pr-2">
                @if (!isQueryingReferenceNumber()) { @switch (referenceNumberFound$ | async) { @case (true) {
                <span class="bg-green-500 rounded-full text-white p-1 flex items-center justify-center">
                    <span class="icon-checkmark-medium"></span>
                </span>
                } @case (false) {
                <span class="bg-red-500 rounded-full text-white p-1 flex items-center justify-center">
                    <span class="icon-close"></span>
                </span>
                } } }
            </span>
        </sag-ui-input>
        @if(isQueryingReferenceNumber()) {
        <div class="animate-pulse w-full">
            <div class="px-2 py-1 w-full bg-gradient-to-r from-shs-gray-4 via-shs-gray-5 text-white text-sm">
                Query database ...
            </div>
        </div>
        }
        <sag-ui-radio-group label="Are you reporting a Product Complaint?" direction="row" [required]="true">
            <sag-ui-radio name="productDiscrepancy" formControlName="productDiscrepancy" [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio name="productDiscrepancy" formControlName="productDiscrepancy" [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>
        <sag-ui-radio-group label="Filing COD within 40 days of ship date/PGI?" direction="row" [required]="true">
            <sag-ui-radio name="pgiWithin40Days" formControlName="pgiWithin40Days" [value]="true">Yes</sag-ui-radio>
            <sag-ui-radio name="pgiWithin40Days" formControlName="pgiWithin40Days" [value]="false">No</sag-ui-radio>
        </sag-ui-radio-group>
        <sag-ui-select
            [required]="true"
            label="International Nature of Complaint"
            placeholder="Please Select ..."
            formControlName="natureOfComplaint"
        >
            @for (natureOfComplaint of natureOfComplaints | keyvalue; track $index) {
            <sag-ui-option [value]="natureOfComplaint.value">{{ natureOfComplaint.value }}</sag-ui-option>
            }
        </sag-ui-select>
    </div>
</section>
